import { ErrorMessage } from "@octopus-energy/coral/atoms"
import { useField } from "formik"

type Props = { field: string }

export function FormikErrorMessage({ field }: Props) {
    const [_, { error }] = useField(field)

    if (typeof error === "string") {
        return <ErrorMessage message={error} />
    }

    return null
}
